// extracted by mini-css-extract-plugin
export default {"title":"SearchResults_title__K+JuI","personajes":"SearchResults_personajes__4LrsP"};